import citiesAndDelegations from "./citiesAndDelegations.js";

// Search-only spellings of existing delegations: never listed as options of their own.
// Scoped by city because "Ezzouhour" is also a real delegation of Tunis and Kasserine.
const delegationAliases = {
  Sousse: {
    "Cité Zouhour": ["Ezzouhour"],
    "Thrayat": ["Thrayet"],
    "Zawiya": ["Zaouia"],
    "Cité Manazah": ["Manazeh"],
  },
};

const fold = (value) =>
  String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();

export const aliasesOf = (city, delegation) => delegationAliases[city]?.[delegation] ?? [];

// Catalog name of `value` in `city` (exact name, accent/case-insensitive, or alias); otherwise `value` unchanged.
export function canonicalDelegation(city, value) {
  const wanted = fold(value);
  if (!wanted) return value;
  for (const delegation of citiesAndDelegations[city] ?? [])
    if (fold(delegation) === wanted || aliasesOf(city, delegation).some((alias) => fold(alias) === wanted))
      return delegation;
  return value;
}

export default delegationAliases;
